import React from 'react';
import PropTypes from 'prop-types';

import { TEAL_500 } from 'styles/colors';
import { Typography } from '@tkww/the-bash-frontend';

export const paragraph = ({ children }) => (
  <Typography m={0} mb={1}>
    {children}
  </Typography>
);
paragraph.propTypes = {
  children: PropTypes.node,
};
paragraph.defaultProps = {
  children: [],
};

export const link = ({ href, children }) => {
  const regex = new RegExp(/^\/(?!\/)./);
  const props = {
    target: '_blank',
    style: {
      color: TEAL_500,
    },
    href,
  };

  if (!regex.test(href)) {
    props.rel = 'noopener noreferrer nofollow';
  }

  return <a {...props}>{children}</a>;
};
link.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
};
link.defaultProps = {
  href: '',
  children: [],
};

export default {
  paragraph,
  link,
};
